"use strict";

define(['app', 'jquery', './templates/notification.html', './models/Notification', './views/Notification'], function (app, $, tmplContainer, NotificationModel, NotificationView) {
  var NotificationsCollection = app.Backbone.Collection.extend({
    model: NotificationModel
  });
  return app.Marionette.CompositeView.extend({
    template: tmplContainer,
    options: {
      scrollTo: true,
      scrollToAnimationDelay: 1000
    },
    templateHelpers: function templateHelpers() {
      var self = this;
      return {
        isList: self.collection.length > 1,
        classes: self.getBoxClasses()
      };
    },
    childViewContainer: 'ul',
    childView: NotificationView,
    filter: function filter(child) {
      if (this.hasError()) {
        return child.get('type') === 'error';
      } else {
        return child.get('type') !== 'error';
      }
    },
    getBoxClasses: function getBoxClasses() {
      var classes = ['box', 'box__pad'];

      if (this.collection.length === 0) {
        classes.push('is-hidden');
      } else if (this.hasError()) {
        classes.push('box--alert');
      } else {
        classes.push('box--success');
      }

      return classes.join(' ');
    },
    hasError: function hasError() {
      return this.collection.where({
        type: 'error'
      }).length > 0;
    },
    onNotificationAdd: function onNotificationAdd(type, message) {
      this.collection.add({
        type: type,
        msg: message
      });
    },
    onNotificationGroupAdd: function onNotificationGroupAdd(arrayOfNotification) {
      this.collection.add(arrayOfNotification);
    },
    onNotificationRemove: function onNotificationRemove(id) {
      this.collection.where({
        id: id
      }).remove();
    },
    onNotificationClean: function onNotificationClean() {
      this.collection.reset();
    },
    onNotificationShow: function onNotificationShow(arrayOfNotification) {
      this.collection.reset(arrayOfNotification);

      if (this.getOption('scrollTo')) {
        $('html, body').animate({
          scrollTop: this.$el.offset().top - this.$el.outerHeight()
        }, this.getOption('scrollToAnimationDelay'));
      }
    },
    setGlobalHandlers: function setGlobalHandlers() {
      var self = this;
      var id = this.getOption('id') ? this.getOption('id') + ':' : '';
      app.events.commands.setHandler('notification:' + id + 'add', function (type, message) {
        self.triggerMethod('notification:add', type, message);
      });
      app.events.commands.setHandler('notification:' + id + 'group:add', function (arrayOfNotification) {
        self.triggerMethod('notification:group:add', arrayOfNotification);
      });
      app.events.commands.setHandler('notification:' + id + 'remove', function (_id) {
        self.triggerMethod('notification:remove', _id);
      });
      app.events.commands.setHandler('notification:' + id + 'clean', function () {
        self.triggerMethod('notification:clean');
      });
      app.events.commands.setHandler('notification:' + id + 'show', function (arrayOfNotification) {
        self.triggerMethod('notification:show', arrayOfNotification);
      });
    },
    initialize: function initialize(options) {
      var notifications = [];
      if (options.notifications) notifications = options.notifications;
      this.collection = new NotificationsCollection(notifications);
      this.setGlobalHandlers();
      this.collection.on('all', this.render.bind(this));
    }
  });
});